import {
  Directive, Input, EventEmitter, ElementRef,
  Renderer2, Inject, SimpleChanges, OnChanges
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Directive({
  selector: '[set-focus]'
})
export class FocusDirective implements OnChanges {

  // @Input('focus') focusEvent: EventEmitter<boolean>;
  @Input('set-focus') focusMe: boolean;

  constructor( @Inject(ElementRef) private element: ElementRef, private renderer: Renderer2) { }

  /*
  public ngOnInit() {
    this.focusEvent.subscribe((event: any) => {
    this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
    });
  }
  */

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['focusMe'] && changes['focusMe'].currentValue) {
      // this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
      Observable.timer(5).subscribe(() => {
        this.element.nativeElement.focus();
      });
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/directives/focus.directive.ts